import baseSick, { round2 } from '../common/sick';

export function getDailyBase(income) {
	return round2((income * 12) / 365);
}

export default function({ pay, pay_hour, hours, days, year }) {
	return baseSick({
		dailyBase: getDailyBase(pay),
		pay_hour,
		hours,
		days,
		year,
	});
}
